export default {
  'buttons.save': 'Save Changes',
  'buttons.cancel': 'Cancel',
  'buttons.reset': 'Reset',
  'buttons.nextStep': 'Next Step',
  'buttons.previousStep': 'Previous Step',
  'buttons.delete': 'Delete',
};
